import { createLocalizationContext as createAppUiLocalizationContext } from "@variocube/app-ui";
import * as React from "react";
import { useEffect, useState } from "react";
import { usePlatform, useStorageItemValue } from "../hooks/context.js";
import en from "./en.json";
import de from "./de.json";
import et from "./et.json";
import fr from "./fr.json";
import it from "./it.json";
import cs from "./cs.json";
import pl from "./pl.json";
import tr from "./tr.json";
import no from "./no.json";
const DEFAULT_LANGUAGE = "en";
const UI_I18N = {
    de,
    en,
    et,
    fr,
    it,
    cs,
    pl,
    tr,
    no,
};
/**
 * Creates a localization context for apps.
 *
 * It injects the default localizations of cube-ui components and allows overriding
 * through the `i18n` storage key.
 */
export function createLocalizationContext(messages) {
    function getMessages(language) {
        var _a;
        return (_a = messages[language]) !== null && _a !== void 0 ? _a : messages[DEFAULT_LANGUAGE];
    }
    const { LocalizationProvider: AppUiLocalizationProvider, useLocalization } = createAppUiLocalizationContext({
        load: async (language) => {
            console.info("loading language", language);
            const langMessages = getMessages(language);
            try {
                return {
                    ...UI_I18N[DEFAULT_LANGUAGE],
                    ...UI_I18N[language],
                    ...langMessages,
                };
            }
            catch (error) {
                console.error(`Error loading language ${language}`, error);
                throw error;
            }
        },
        fallback: DEFAULT_LANGUAGE,
        missing: "fallback"
    });
    function LocalizationProvider({ children, app }) {
        const platform = usePlatform();
        const overrides = useStorageItemValue("i18n");
        const [language, setLanguage] = useState(platform.language);
        useEffect(() => {
            platform.addLanguageListener(setLanguage);
            return () => platform.removeLanguageListener(setLanguage);
        }, []);
        useEffect(() => {
            const langMessages = getMessages(language !== null && language !== void 0 ? language : DEFAULT_LANGUAGE);
            app.name = langMessages.appName;
            app.description = langMessages.appDescription;
            app.updateLauncherItems();
        }, [language]);
        return (React.createElement(AppUiLocalizationProvider, { language: language, overrides: overrides, onChangeLanguage: NOP }, children));
    }
    return {
        LocalizationProvider,
        useLocalization,
        SUPPORTED_LANGUAGES: Object.keys(messages),
    };
}
const NOP = () => { };
//# sourceMappingURL=index.js.map